import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import { Typography } from "@mui/material";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import { nullChecker } from "@assets/utils/check";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.grey[400],
    color: theme.palette.grey[800],
    borderBottom: 0,
    paddingTop: 28,
    paddingBottom: 28,
  },
  [`&.${tableCellClasses.head}:first-of-type`]: {
    borderTopLeftRadius: "15px",
    borderBottomLeftRadius: "15px",
  },
  [`&.${tableCellClasses.head}:last-of-type`]: {
    borderTopRightRadius: "15px",
    borderBottomRightRadius: "15px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    paddingTop: 35,
    paddingBottom: 35,
    borderColor: "#FAFAFB",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "& .test1234": {
    backgroundColor: "red",
  },
  "& tr:first-of-type": {
    borderTopLeftRadius: "15px",
  },
  backgroundColor: "#fff",
  borderRadius: "100px",
  "&:first-of-type": {
    "& td:first-of-type": {
      borderTopLeftRadius: "15px",
    },
    "& td:last-of-type": {
      borderTopRightRadius: "15px",
    },
  },
  "&:last-of-type": {
    "& td:first-of-type": {
      borderBottomLeftRadius: "15px",
    },
    "& td:last-of-type": {
      borderBottomRightRadius: "15px",
    },
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "& tr:last-of-type ": {
    backgroundColor: "red",
    borderTopLeftRadius: "15px",
  },
  "&:hover": {
    backgroundColor: "rgb(19 1 1 / 3%)",
  },
}));

const AdvertiserInfoTable = ({ infolist, onOpen, onChange }) => {
  const pagenationList = (rows, page) => {
    let pageStart = (page - 1) * 10;
    let pageEnd = page * 10;
    let filterView = null;
    if (infolist.search === "" || !infolist.search) {
      filterView = rows.filter(
        (row, index) => pageStart <= index && index < pageEnd
      );
    } else {
      const searchFilter = rows.filter((data) => {
        return data.name.toLowerCase().includes(infolist.search);
      });
      filterView = searchFilter.filter(
        (row, index) => pageStart <= index && index < pageEnd
      );
    }

    return filterView;
  };

  const rowChecker = (rows = null) => {
    let num = 0;
    if (
      rows === null ||
      rows === undefined ||
      rows === "" ||
      rows.length === 0
    ) {
      num = 1;
    } else {
      if (infolist.search === "" || !infolist.search) {
        num = Math.ceil(rows.length / 10);
      } else {
        const searchFilter = rows.filter((data) => {
          return data.name.toLowerCase().includes(infolist.search);
        });
        num = Math.ceil(searchFilter.length / 10);
      }
    }
    return num;
  };

  return (
    <>
      <TableContainer sx={{ minHeight: 587, mt: 1.5 }}>
        <Table
          sx={{
            minWidth: 700,
            borderCollapse: "collapse",
          }}
          aria-label="customized table"
        >
          <TableHead>
            <TableRow>
              <StyledTableCell align="center">
                <Typography variant="body">광고주</Typography>
              </StyledTableCell>
              <StyledTableCell align="center">
                <Typography variant="body">아이디</Typography>
              </StyledTableCell>
              <StyledTableCell align="center">
                <Typography variant="body">담당 이메일</Typography>
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              "&::before": {
                lineHeight: "3em",
                content: `"."`,
                color: "white",
              },
            }}
          >
            {pagenationList(infolist.rows, infolist.page).map((row) => (
              <StyledTableRow
                key={row._id}
                sx={{
                  cursor: "pointer",
                  "&:hover": { backgroundColor: "#EDF7FE" },
                }}
                onClick={() => onOpen(row)}
              >
                <StyledTableCell component="td" scope="row" align="center">
                  {row.name}
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Typography variant="body">{row.code}</Typography>
                </StyledTableCell>
                <StyledTableCell align="center">
                  {nullChecker(row.email, "없음")}
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {rowChecker(infolist.rows) !== 0 && (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ pt: 4, pb: 4, mt: 2, mb: 2 }}
        >
          <Stack spacing={2}>
            <Pagination
              color="primary"
              count={rowChecker(infolist.rows)}
              page={infolist.page}
              onChange={onChange}
            />
          </Stack>
        </Grid>
      )}
    </>
  );
};

export default AdvertiserInfoTable;
